<template>
  <div class="stock-trace-main">
    <el-card class="stock-trace-filters">
      <el-row type="flex" justify="space-between">
        <el-col :span="18">
          <el-row type="flex" justify="start">
            <el-col :span="12">
              <el-date-picker v-model="timeRange" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" placeholder="el-select date and time" size="large" >
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <el-select v-model="actionType" size="large" placeholder="Action Type" clearable>
                <el-option v-for="item in actionTypeList" :value="item" :key="item">{{ item }}</el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <span style="margin: 0 10px;">
              <el-button @click="searchPage" type="primary" icon="search" size="large">Search</el-button>
            </span>
            <el-button @click="clearFilters" type="ghost" size="large">Reset</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-table :data="stockTraceData">
        <el-table-column prop="timestamp" label="Time" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.timestamp']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operationType" label="Action Type" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.operationType']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderLineNum" label="OrderLine No." min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.orderLineNum']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="boutiqueStock" label="BoutiqueStock" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.boutiqueStock']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="store" label="Store(Aft)" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.store']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reserved" label="Reserved(Aft)" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.reserved']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="confirmed" label="Confrimed(Aft)" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.confirmed']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="Locked(Aft)" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span class="manipulate">{{scope.row['content.locked']}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" min-width="120">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if="scope.row['content.requestId']==''" class="manipulate">no original data</span>
            <el-button v-else type="primary" size="small" class="manipulate" @click.stop="popOriginalData(scope.row['content.requestId'])">original data</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagePos" background @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[15, 25, 30, 50]" :page-size="pageSize" layout="total, prev, pager, next,sizes, jumper" :total="totalCount"></el-pagination>

    </el-card>
    <Modal v-model="isOrgDataVisable" title="Original Data" @on-cancel="cancelData">
      <div style="word-wrap:break-word">{{originalData}}</div>
    </Modal>
  </div>
</template>
<script>
import util from "@/utils/util";
import * as TraceService from "@/api/trace";
export default {
  data() {
    return {
      skuId: 0,
      originalData: "",
      isOrgDataVisable: false,
      totalCount: 0,
      pageSizeOpts: [25, 50, 100, 200, 300],
      pageSize: 25,
      currentPage: 1,
      timeRange: [],
      actionType: "",
      actionTypeList: [],
      stockTraceData: []
    }
  },
  mounted() {
    this.skuId = this.$route.params.skuId;
    this.initTimeRange();
    this.refreshTable();
  },
  methods: {
    initTimeRange() {
      let end = new Date().getTime();
      let start = end - 60 * 60 * 1000 * 24 * 30;
      this.timeRange = [new Date(start), new Date(end)];
    },

    popOriginalData(requestId) {
      this.isOrgDataVisable = true;

      TraceService.getOrgData(requestId).then(res => {
        if (res.data.status === 1) {
          this.originalData = res.data.data;
        } else {
          this.$message(res.data.data);
        }
      })
    },
    refreshTable() {
      let param = {
        from: this.timeRange[0].getTime(),
        to: this.timeRange[1].getTime(),
        line: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize
      };
      console.log("this.currentPage " + this.currentPage);
      console.log(JSON.stringify(param));
      TraceService.getSkuStockTrace(this.skuId, param).then(res => {
        if (res.data.status === 1) {
          this.actionTypeList = [];
          res.data.data.operationTypes.forEach(element => {
            this.actionTypeList.push(element["content.operationType"].toUpperCase());
          });
          res.data.data.datas.forEach(element => {
            for (let key in element) {
              if (element[key] === "null") {
                element[key] = "";
              }
              if (key === "content.timestamp") {
                element[key] = util.dateFormat(new Date(parseInt(element[key])), "yyyy-MM-dd  hh:mm:ss");
              }

              if (key === "content.operationType") {
                element[key] = element[key].toUpperCase();
              }
            }
          });
          this.stockTraceData = res.data.data.datas;
          // console.log(JSON.stringify(this.stockTraceData));
          this.totalCount = res.data.data.total;
        } else {
          this.$message(res.data.data);
        }
      })
    },
    pageChange(page) {
      this.currentPage = page;
      this.refreshTable();
    },

    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.refreshTable();
    },
    searchPage() {
      // console.log(this.timeRange);
      this.refreshTable();

    },
    clearFilters() {
      this.currentPage = 1;
      this.stockTraceData = [];
      this.actionType = "";
    },
    cancelData() {

    }
  }
}

</script>
<style lang="less">
.pagePos {
  margin-top: 20px;
  transform: translateX(60%);
}
@import "./stock-trace.less";
@import "../../../styles/common.less";
</style>